import React, { useEffect, useState } from 'react';
import { HashRouter, Switch, Route, Link, Redirect } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import $ from 'jquery';
import Home from './Home';
import OticonMoreOverview from './OticonMoreOverview';
import Evidence from './Evidence';
import MainNav from './elements/MainNav';
import BrainHearingTechnologyMain from './BrainHearingTechnologyMain';
import Connectivity from './Connectivity';
import FamilyOverview from './FamilyOverview';

export default function App() {
  const resizeWrapper = () => {
    const $window = $(window);
    const $wrapper = $('#wrapper');
    const width = $window.width();
    const height = $window.height();
    const wrapper_h = $wrapper.height();
    const wrapper_w = $wrapper.width();
    const scale = height / wrapper_h;
    const base_w = 1024;

    $wrapper.css({
      transform: `scale(${scale})`,
    });

    if (base_w * scale > width) {
      const new_scale = width / wrapper_w;
      const origin = new_scale > 1 ? 'top center' : '0 0';
      $wrapper.css({
        transform: `scale(${new_scale})`,
        'transform-origin': origin,
        'z-index': 0,
      });
    }
  };
  useEffect(() => {
    $(window).resize(resizeWrapper);
    resizeWrapper();

    return () => {
      // cleanup
    };
  }, []);

  return (
    <HashRouter>
      <div id="wrapper">
        <div id="portal" />
        <div>
          <div>
            <main className="main-page-content" />
          </div>
        </div>
        <Switch>
          <Route path="/oticon-more-overview" component={OticonMoreOverview} />
          <Route
            path="/brainhearing-technology"
            component={BrainHearingTechnologyMain}
          />
          <Route path="/connectivity" component={Connectivity} />
          <Route path="/evidence" component={Evidence} />
          {/* <Route path="/family-overview" component={FamilyOverview} /> */}
          <Route path="/test" component={FamilyOverview} />
          <Route path="/family-overview" component={FamilyOverview} />
          <Route path="/" component={Home} />
          <Redirect to="/" />
        </Switch>

        <MainNav />
      </div>
    </HashRouter>
  );
}
